import VueRouter from 'vue-router'
import qs from 'qs'
import { isEqual } from 'lodash'
import {
  ensureLocalsLoaded,
  ensureSession,
  ensureSignedOut,
  ensureSignedIn,
  initialScrollWithHash,
  initializeBeacon,
  loadDiscount
  // metaSocialLoad
} from './hooks'

export default (vueInstance, routes = []) => {
  vueInstance.use(VueRouter)

  const router = new VueRouter({
    mode: 'history',
    routes,

    parseQuery(query) {
      return qs.parse(query)
    },

    stringifyQuery(query) {
      const result = qs.stringify(query)

      return result ? `?${result}` : ''
    },

    scrollBehavior(to, from, savedPosition) {
      // allowing per-route scrollBehavior
      if (to.meta.scrollBehavior) {
        return to.meta.scrollBehavior(to, from, savedPosition)
      }

      // smooth scroll for same-path hash nav
      const isSamePathHash = to.hash && to.path === from.path
      const isRootWithHash = to.path.endsWith('/') && to.hash
      if (isSamePathHash || isRootWithHash) {
        return {
          selector: to.hash,
          behavior: 'smooth'
        }
      }

      // back/forward nav
      if (savedPosition) {
        return { ...savedPosition, behavior: 'auto' }
      }

      // query-only change → no scroll
      const onlyQueryChanged = to.path === from.path && to.hash === from.hash && !isEqual(to.query, from.query)
      if (onlyQueryChanged) {
        return false
      }

      // path or hash change → scroll to top
      if (to.path !== from.path || to.hash !== from.hash) {
        return { x: 0, y: 0, behavior: 'auto' }
      }

      return false
    }
  })

  router.beforeEach(ensureLocalsLoaded(vueInstance))
  router.beforeEach(ensureSession(vueInstance))
  router.beforeEach(ensureSignedOut(vueInstance))
  router.beforeEach(ensureSignedIn(vueInstance))
  router.beforeEach(loadDiscount(vueInstance))
  // router.beforeEach(metaSocialLoad(vueInstance))
  router.afterEach(initialScrollWithHash(vueInstance))
  router.afterEach(initializeBeacon(vueInstance))

  return router
}
